import { persistentMap } from "@nanostores/persistent";

type SharedCartSession = {
  cartId: string;
  secret: string;
};

export const $sharedCartSession = persistentMap<SharedCartSession>(
  "sharedCart:",
  { cartId: "", secret: "" },
  {
    encode: JSON.stringify,
    decode: JSON.parse,
  }
);

export function setSharedCartSession(cartId: string, secret: string) {
  $sharedCartSession.set({ cartId, secret });
}

export function clearSharedCartSession() {
  $sharedCartSession.set({ cartId: "", secret: "" });
}
